import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import UIModal from 'UIComponents/dialog/UIModal';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const getTwoFactorAuthBackupSetup = () => import( /* webpackChunkName: "twoFactorAuth" */'../lib/twoFactorAuthExpensiveModules').then(module => module.TwoFactorAuthBackupSetup);
export default Loadable({
  loader: getTwoFactorAuthBackupSetup,
  LoadingComponent: ({
    pastDelay
  }) => pastDelay ? /*#__PURE__*/_jsx(UIModal, {
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      minHeight: "200"
    })
  }) : null
});